import type { ComponentDefinition } from '../factory';

export const progressRingDefinition = {
  base: 'items-center justify-center',
  variants: {
    size: {
      sm: 'h-7 w-7',
      md: 'h-[92px] w-[92px]',
    },
  },
  defaultVariants: {
    size: 'md',
  },
  slots: {
    track: {
      base: 'text-primary/20',
    },
    progress: {
      base: 'text-primary',
    },
    value: {
      base: 'text-foreground font-semibold',
      variants: {
        size: {
          sm: 'text-xs',
          md: 'text-lg',
        },
      },
    },
    label: {
      base: 'text-muted-foreground',
      variants: {
        size: {
          sm: 'text-[11px]',
          md: 'text-xs',
        },
      },
    },
  },
} satisfies ComponentDefinition;

export type ProgressRingSize = keyof typeof progressRingDefinition.variants.size;
